import { compose } from 'redux';

import {
    WithFetchDatasByParamsFromCMS,
    WithFetchDatasByParamsFromCMSInputProps,
} from 'modules/shared-cms-advanced/hocs';
import { WithStatelessDatasFetchingByParameters, WithRemoteActions } from 'modules/shared/hocs';

import { gameService } from '../../services';
import { Game, GetGame } from '../../models';

import { QUERY } from './game-query';
import { GameLoader } from './game-page-loader';
import { GameProps, GameRemoteActionsProps } from './game-type';

const enhancer = compose<React.ComponentType<WithFetchDatasByParamsFromCMSInputProps & GetGame>>(
    WithStatelessDatasFetchingByParameters<Game, GameProps, GetGame>(
        gameService.get,
        GameLoader,
        'redirect',
        'apiGame',
        ['id'],
    ),
    WithFetchDatasByParamsFromCMS<GameProps>(
        GameLoader,
        QUERY,
        'queryJeuContents',
        [{ filter: 'data/gameId/iv eq $id' }],
        'cmsGame',
    ),
    WithRemoteActions<GameRemoteActionsProps>({
        createParticipation: {
            action: gameService.addParticipation,
            errorMessages: [
                {
                    message: 'Le jeu est fermé',
                    code: 50.151,
                },
                {
                    message: 'Erreur à la création du dossier',
                    code: 10.105,
                },
            ],
        },
    }),
);

export default enhancer;
